import { useApolloClient } from "@apollo/client";
import { AddonPanelFragmentDoc } from "../types";
import currency from "currency.js";
export const removeAddon = (benefitId, id) => {
    const client = useApolloClient();
    return () => {
        client.cache.modify({
            id: `SubscriptionBenefit:${benefitId}`,
            fields: {
                addons(existingAddonRefs = []) {
                    const filtered = existingAddonRefs.filter((a) => a.__ref !== `Addon:${id}`);
                    return [...filtered];
                },
            },
        });
    };
};
export const updateAddon = (id, field) => {
    const client = useApolloClient();
    return (ev) => {
        const addonFields = client.readFragment({
            id: `Addon:${id}`,
            fragment: AddonPanelFragmentDoc,
        });
        if (!addonFields)
            return;
        // Handle different input types
        let value;
        if (typeof ev === 'string') {
            value = ev;
        }
        else {
            const target = ev.target;
            // For checkboxes, we need to check both the type and the current platformId
            if (target.type === 'checkbox') {
                // If it's already SKIP, uncheck it, otherwise check it
                value = addonFields.platformId === "SKIP" ? "" : "SKIP";
            }
            else {
                value = target.value;
            }
        }
        const updatedFields = Object.assign(Object.assign({}, addonFields), { [field]: value });
        if (field === 'platformId' && value) {
            updatedFields.platformName = 'native';
        }
        client.writeFragment({
            id: `Addon:${id}`,
            fragment: AddonPanelFragmentDoc,
            data: updatedFields,
        });
    };
};
export const updateAddonCost = (id) => {
    const client = useApolloClient();
    const numberRegex = /([\d,]+)\.*(\d{0,2})?/;
    return (ev) => {
        const val = ev.target.value.match(numberRegex) || ["0.00", "0", "00"];
        if (val[1]) {
            const newAmount = currency(`${val[1] || "0"}.${val[2] || "0"}`).intValue;
            client.cache.modify({
                id: `Addon:${id}`,
                fields: {
                    additionalCost: () => ({ amount: newAmount }),
                },
            });
        }
    };
};
export const updateAddonApplyDiscount = (id) => {
    const client = useApolloClient();
    return (ev) => {
        if (ev.target.checked) {
            client.cache.modify({
                id: `Addon:${id}`,
                fields: {
                    applyDiscount: () => true,
                },
            });
        }
        else {
            client.cache.modify({
                id: `Addon:${id}`,
                fields: {
                    applyDiscount: () => false,
                },
            });
        }
    };
};
export const updateAddonDontRollOver = (id) => {
    const client = useApolloClient();
    return (ev) => {
        if (ev.target.checked) {
            client.cache.modify({
                id: `Addon:${id}`,
                fields: {
                    dontRollOver: () => true,
                },
            });
        }
        else {
            client.cache.modify({
                id: `Addon:${id}`,
                fields: {
                    dontRollOver: () => false,
                },
            });
        }
    };
};
